module.exports = __webpack_public_path__ + "img/pr-35.03c4f1b0.png";